import React from "react";
import NewAdminDashboard from "../components/NewAdminDashboard";

/**
 * AdminDashboard Page - Main admin interface
 * Uses the new integrated dashboard design
 * Protected by ProtectedRoute guard in routes.tsx
 */
const AdminDashboard: React.FC = () => {
  return <NewAdminDashboard />;
};

export default AdminDashboard;

